import React from 'react';
import { Calendar, CheckCircle, Sparkles, MapPin } from 'lucide-react';
export function StatsRow() {
  const stats = [{
    label: 'Fissi Oggi',
    value: '1',
    subtext: 'Da Google Calendar',
    icon: Calendar,
    iconColor: 'text-navy',
    iconBg: 'bg-navy/10'
  }, {
    label: 'Confermati',
    value: '3',
    subtext: 'Su CleanAI',
    icon: CheckCircle,
    iconColor: 'text-teal-deep',
    iconBg: 'bg-teal-deep/10'
  }, {
    label: 'Proposti AI',
    value: '2',
    subtext: 'Da confermare',
    icon: Sparkles,
    iconColor: 'text-teal-deep',
    iconBg: 'bg-teal-deep/10'
  }, {
    label: 'Opportunità',
    value: '12',
    subtext: 'Nella tua zona',
    icon: MapPin,
    iconColor: 'text-teal-deep',
    iconBg: 'bg-teal-deep/10'
  }];
  return <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-2320">
      {stats.map((stat, index) => <div key={index} className="bg-white border border-gray-200 rounded-xl p-4 lg:p-5" data-id="element-2321">
          <div className="flex items-center justify-between mb-2" data-id="element-2322">
            <p className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-2323">
              {stat.label}
            </p>
            <div className={`w-7 h-7 rounded-lg ${stat.iconBg} flex items-center justify-center`} data-id="element-2324">
              <stat.icon size={14} className={stat.iconColor} data-id="element-2325" />
            </div>
          </div>
          <p className="text-2xl lg:text-3xl font-bold text-navy tracking-tight leading-none" data-id="element-2326">
            {stat.value}
          </p>
          {stat.subtext && <p className="text-xs text-gray-400 mt-1.5" data-id="element-2327">{stat.subtext}</p>}
        </div>)}
    </div>;
}